document.addEventListener('DOMContentLoaded', () => {
  const rootStyles = getComputedStyle(document.documentElement);
  const pdp = document.querySelector('.pdp-main');
  const themeValue = (name, fallback) => {
    const fromPdp = pdp ? getComputedStyle(pdp).getPropertyValue(name) : '';
    return (fromPdp || rootStyles.getPropertyValue(name) || fallback).trim();
  };

  const headingColor = themeValue('--heading-color', '85, 70, 63');
  const brandColor = themeValue('--brand-color', '95, 125, 83');
  const foreground = themeValue('--color-foreground', '18, 18, 18');
  const background = themeValue('--color-background', '255, 255, 255');
  const headingFont = themeValue('--font-heading-family', 'inherit');
  const bodyFont = themeValue('--font-body-family', 'inherit');
  const starColor = themeValue('--pdp-star-color', '#f0a13a');

  let fontFaces = '';
  for (const sheet of document.styleSheets) {
    if (sheet.href) continue;
    try {
      for (const rule of sheet.cssRules) {
        if (rule instanceof CSSFontFaceRule) fontFaces += rule.cssText + '\n';
      }
    } catch (e) {
      continue;
    }
  }

  const formCss = `
    ${fontFaces}
    #scm-form-review {
      font-family: ${bodyFont};
      color: rgb(${foreground});
    }
    #scm-form-review h2 {
      font-family: ${headingFont};
      font-size: 26px;
      line-height: 34px;
      font-weight: 700;
      color: rgb(${headingColor});
    }
    #scm-form-review .input-rating p,
    #scm-form-review label,
    #scm-form-review .scm-label {
      font-family: ${bodyFont};
      font-size: 14px;
      line-height: 22px;
      font-weight: 600;
      color: rgb(${headingColor});
    }
    #scm-form-review .block-item-star svg path {
      fill: rgba(${foreground}, 0.2);
    }
    #scm-form-review .block-item-star.selected-star svg path {
      fill: ${starColor};
    }
    #scm-form-review input[type='text'],
    #scm-form-review input[type='email'],
    #scm-form-review textarea {
      font-family: ${bodyFont};
      font-size: 14px;
      line-height: 22px;
      color: rgb(${foreground});
      background: rgb(${background});
      border: 1px solid rgba(${headingColor}, 0.16);
      border-radius: 10px;
      padding: 12px 14px;
      box-shadow: none;
    }
    #scm-form-review input[type='text']:focus,
    #scm-form-review input[type='email']:focus,
    #scm-form-review textarea:focus {
      border-color: rgb(${brandColor});
      outline: none;
    }
    #scm-form-review input::placeholder,
    #scm-form-review textarea::placeholder {
      color: rgba(${foreground}, 0.45);
    }
    #scm-form-review .scm-btn-submit {
      font-family: ${bodyFont};
      font-size: 15px;
      font-weight: 700;
      color: #fff;
      background: rgb(${brandColor});
      border: none;
      border-radius: 96px;
      padding: 12px 32px;
      min-height: 46px;
      cursor: pointer;
    }
    #scm-form-review .scm-btn-submit:hover {
      filter: brightness(1.08);
    }
    #scm-form-review .result-reviews p.success {
      color: rgb(${brandColor});
    }
    #scm-form-review .result-reviews p.fail,
    #scm-form-review .scm-field-error {
      color: #e0684e;
    }
  `;

  const styleFrame = (frame) => {
    let doc;
    try {
      doc = frame.contentDocument;
    } catch (e) {
      return;
    }
    if (!doc || !doc.querySelector('.scm-write-review') || doc.getElementById('mizzy-review-form-style')) return;
    const style = doc.createElement('style');
    style.id = 'mizzy-review-form-style';
    style.textContent = formCss;
    doc.head.appendChild(style);
  };

  const watchFrame = (frame) => {
    styleFrame(frame);
    frame.addEventListener('load', () => styleFrame(frame));
  };

  document.querySelectorAll('iframe').forEach(watchFrame);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.tagName === 'IFRAME') watchFrame(node);
        else if (node.querySelectorAll) node.querySelectorAll('iframe').forEach(watchFrame);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // The app writes into its iframe after load without firing a load event,
  // so retry a few times while the page settles.
  [1000, 3000, 6000, 10000].forEach((delay) => {
    setTimeout(() => document.querySelectorAll('iframe').forEach(styleFrame), delay);
  });
});
